import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { defaultIfEmpty, map, of } from 'rxjs';
import { HasUnsavedChanges } from 'shared/design-system/data-access/wizard';
import { DialogService } from 'shared/design-system/ui/dialog';

export const stepCanDeactivateGuard = ((component) => {
    const dialogService = inject(DialogService);

    if (!component.hasUnsavedChanges) {
        return of(true);
    }

    return dialogService
        .openDialog({
            header: $localize`:@@menu.wizard.unsavedChanges.title:Unsaved changes`,
            message: $localize`:@@menu.wizard.unsavedChanges.description:Are you sure you want to leave?`,
        })
        .pipe(
            map(() => true),
            defaultIfEmpty(false),
        );
}) satisfies CanDeactivateFn<HasUnsavedChanges>;
